import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "orders",
  class: "flex flex-col gap-3 pb-[150px]"
}

import { ref } from "vue";
import TourCard from "@/components/tours/TourCard.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TourOverview',
  props: ["tours"],
  setup(__props) {


const activeTour = ref(null as string | null);
const setActiveTour = (index: string) => {
  activeTour.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tours, (tour, index) => {
      return (_openBlock(), _createBlock(TourCard, {
        key: index,
        index: index,
        order: tour,
        "active-order": activeTour.value,
        onActiveOrder: setActiveTour
      }, null, 8, ["index", "order", "active-order"]))
    }), 128))
  ]))
}
}

})